import createAsyncAction from 'shared/utils/createAsyncAction';

import createAction from './';

export const SUBMIT_IDENTITY_INFO_FORM = createAsyncAction(createAction('SUBMIT_IDENTITY_INFO_FORM'));

export const submitIdentityInfoForm = () => (dispatch) => dispatch({ type: SUBMIT_IDENTITY_INFO_FORM.success });

